import type {
  AddressType
} from 'be-structures/typescript-generator/assembly'


export const ADDRESSES_TYPES: AddressType[] = ['REGISTRATION', 'POST', 'LIVING', 'BIRTH_PLACE']